import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";
import {H2hWidgetPlaceholder} from "./placeholder/h2h-widget.placeholder";

const H2hWidgetAsyncComponent = AsyncComponent(async () => import('./h2h-widget' /* webpackChunkName: "widget" */ ));

export const H2hWidgetAsync = (props) => {
  return <ErrorBoundaryWrapper isMandatory={props.isFullView}>
    {
      props.isFullView || props.shouldUseSuspense ? <React.Suspense fallback={<H2hWidgetPlaceholder/>}>
        <H2hWidgetAsyncComponent {...props}/>
      </React.Suspense> : <H2hWidgetAsyncComponent {...props}/>
    }
  </ErrorBoundaryWrapper>
}
